import React, { FunctionComponent } from "react";
import { NamedProperty, CodedProperty } from "sprint-common-web";

import { AncillaryContentSubtype } from "../../../../../common/types/AncillaryContentType";
import { PageHeader } from "../../../../../common/ui/layout/header/PageHeader";
import { AncillaryDetailsPageBreadcrumbs } from "../../../common/header/ancillary/AncillaryDetailsPageBreadcrumbs";

interface AncillaryDetailsPageHeaderProps {
    contentType: AncillaryContentSubtype;
    ancillary: NamedProperty;
    airline: CodedProperty;
}

export const OnPremAncillaryDetailsPageHeader: FunctionComponent<AncillaryDetailsPageHeaderProps> = (
    props: AncillaryDetailsPageHeaderProps
) => {
    const { contentType, ancillary, airline } = props;

    return (
        <PageHeader>
            <AncillaryDetailsPageBreadcrumbs contentType={contentType} ancillary={ancillary} airline={airline} />
        </PageHeader>
    );
};
